module.exports = __webpack_public_path__ + "static/media/extension.cc06f52c.mp4";


//////////////////
// WEBPACK FOOTER
// ./src/images/recollect/extension.mp4
// module id = 347
// module chunks = 0